<mon-page-header 
    header="{{'PUE Report' | translate}}"
    subHeader="{{'The Product Utilization and Engagement (PUE) report provides an overview in CSV format of all customers on the environment along with their feature enablement and key metrics.' | translate}}"
    [monIconDirect]="'faDownload'">
</mon-page-header>

<button class="btn btn-secondary" (click)="downloadLatest()">Download latest PUE report</button>